/**
 *
 * @param Date fromDate
 * @param Date toDate
 * @returns Date
 */
export const moveTime = (fromDate = new Date(), toDate) => {
  fromDate.setHours(toDate.getHours());
  fromDate.setMinutes(toDate.getMinutes());
  fromDate.setSeconds(toDate.getSeconds());
  fromDate.setMilliseconds(toDate.getMilliseconds());

  return fromDate;
};

export const changeTime = (fromDate = new Date(), toDate) => {
  let newDate = new Date();
  moveDate(newDate, fromDate);
  moveTime(newDate, toDate);
  return newDate;
};

export const changeDate = (fromDate = new Date(), toDate) => {
  let newDate = new Date();
  moveTime(newDate, fromDate);
  moveDate(newDate, toDate);
  return newDate;
};

/**
 * Move date
 *
 * @param Date fromDate
 * @param Date toDate
 * @returns Date
 */
export const moveDate = (fromDate = new Date(), toDate) => {
  fromDate.setDate(toDate.getDate());
  fromDate.setMonth(toDate.getMonth());
  fromDate.setFullYear(toDate.getFullYear());

  return fromDate;
};



// WEBPACK FOOTER //
// ./src/utilites/date.js